export interface SEOArticle {
  slug: string;
  title: string;
  excerpt: string;
  keywords: string;
  datePublished: string;
  readTime: string;
  imageSeq: string;
}

export const featuredArticles: SEOArticle[] = [
  {
    slug: 'superbuy-spreadsheet-beginner-guide',
    title: 'Superbuy Spreadsheet Beginner Guide 2026: Everything You Need To Know',
    excerpt: 'New to Superbuy Spreadsheet? This comprehensive beginner guide walks you through everything from setting up your first spreadsheet to mastering advanced product organization techniques.',
    keywords: 'Superbuy spreadsheet beginner guide, Superbuy spreadsheet tutorial, how to use Superbuy spreadsheet',
    datePublished: '2026-07-12',
    readTime: '12 min read',
    imageSeq: 'article-beginner-guide-01',
  },
  {
    slug: 'superbuy-spreadsheet-product-organization',
    title: 'How To Organize Products With Superbuy Spreadsheet: Complete Workflow',
    excerpt: 'Learn the proven workflow for organizing hundreds of products using Superbuy Spreadsheet. Discover categorization strategies, filter techniques, and comparison methods.',
    keywords: 'Superbuy spreadsheet organization, product organization spreadsheet, Superbuy product workflow',
    datePublished: '2026-07-10',
    readTime: '10 min read',
    imageSeq: 'article-organization-02',
  },
  {
    slug: 'superbuy-spreadsheet-comparison-guide',
    title: 'Superbuy Spreadsheet vs Manual Search: Why Spreadsheets Win Every Time',
    excerpt: 'Discover why using Superbuy Spreadsheet beats manual browsing. We compare speed, accuracy, and decision-making quality between spreadsheet methods and traditional searching.',
    keywords: 'Superbuy spreadsheet comparison, spreadsheet vs manual search, Superbuy spreadsheet benefits',
    datePublished: '2026-07-08',
    readTime: '8 min read',
    imageSeq: 'article-comparison-03',
  },
];

export const allArticles: SEOArticle[] = [
  ...featuredArticles,
  {
    slug: 'superbuy-spreadsheet-qc-guide',
    title: 'Superbuy Spreadsheet QC Guide: Quality Control Made Simple',
    excerpt: 'Master quality control with Superbuy Spreadsheet. Learn how to track QC photos, verify product details, and ensure every item meets your standards before shipping.',
    keywords: 'Superbuy QC spreadsheet, quality control guide, Superbuy spreadsheet QC',
    datePublished: '2026-07-05',
    readTime: '9 min read',
    imageSeq: 'article-qc-04',
  },
  {
    slug: 'superbuy-spreadsheet-shipping-guide',
    title: 'Superbuy Spreadsheet Shipping Guide: Save Money On Every Package',
    excerpt: 'Optimize your shipping costs using Superbuy Spreadsheet. Compare carriers, calculate estimates, and track packages all from one organized document.',
    keywords: 'Superbuy shipping spreadsheet, Superbuy spreadsheet shipping guide, shipping cost spreadsheet',
    datePublished: '2026-07-03',
    readTime: '11 min read',
    imageSeq: 'article-shipping-05',
  },
  {
    slug: 'superbuy-spreadsheet-best-finds',
    title: 'Best Superbuy Spreadsheet Finds 2026: Top Products This Year',
    excerpt: 'Curated list of the best products discovered through Superbuy Spreadsheet this year. From sneakers to accessories, see what the community is researching right now.',
    keywords: 'Superbuy spreadsheet finds, best Superbuy products 2026, Superbuy spreadsheet recommended',
    datePublished: '2026-07-01',
    readTime: '7 min read',
    imageSeq: 'article-finds-06',
  },
];